import EFPicture from 'elem/compCommon/EFPicture';
import EfLink from 'elem/ui/ef-link';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function F({ ICON_AMAZON }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('amazonsale');
    const productList = [
        {
            key: 'product1',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724054900417/amazon_sale_f_product1.png',
            usp: t('sectionF_product_1_usp'),
            title: t('sectionF_product_1_title'),
            price: 66000,
            original_price: 88000,
            link: 'https://www.amazon.co.jp/dp/B0D2NYT632',
        },
        {
            key: 'product2',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724054900800/amazon_sale_f_product2.png',
            usp: t('sectionF_product_2_usp'),
            title: t('sectionF_product_2_title'),
            price: 14025,
            original_price: 16500,
            link: 'https://www.amazon.co.jp/dp/B0DB797LFL?ref=myi_title_dp',
        },
        {
            key: 'product3',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724054900968/amazon_sale_f_product3.png',
            usp: t('sectionF_product_3_usp'),
            title: t('sectionF_product_3_title'),
            price: 32175,
            original_price: 42900,
            link: 'https://www.amazon.co.jp/dp/B0CX1SLMCB?ref=myi_title_dp',
        },
        {
            key: 'product4',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724054900591/amazon_sale_f_product4.png',
            usp: t('sectionF_product_4_usp'),
            title: t('sectionF_product_4_title'),
            price: 51975,
            original_price: 69300,
            link: 'https://www.amazon.co.jp/dp/B0CX1Q6D5T?ref=myi_title_dp',
        },
        {
            key: 'product5',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724054900168/amazon_sale_f_product5.png',
            usp: t('sectionF_product_5_usp'),
            title: t('sectionF_product_5_title'),
            price: 94875,
            original_price: 126500,
            link: 'https://www.amazon.co.jp/dp/B09Y5VBS63/ref=emc_bcc_2_i?th=1',
        },
    ];

    return (
        <div id="amazon-sale-F" className={`amazon-sale-F ${css['amazon-sale-F']}`}>
            <div className="section-content">
                <p className="title">{t('sectionF_title')}</p>
                <Swiper
                    className="product-content"
                    modules={[Scrollbar, Navigation]}
                    navigation={true}
                    spaceBetween={15}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        draggable: true,
                    }}
                >
                    {productList.map((item: any) => (
                        <SwiperSlide className="product" key={item.key}>
                            <div className="off">
                                <EFPicture
                                    className="off-icon"
                                    src="https://websiteoss.ecoflow.com/upload/image/1724054722919/amazon_sale_f_off.png"
                                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1724054722919/amazon_sale_f_off.png"
                                    alt={t('sectionF_title')}
                                />
                                <p className="off-text">{Math.round((1 - item.price / item.original_price) * 100) || 0}%</p>
                            </div>
                            <p className="product-usp">{item.usp}</p>
                            <EFPicture className="product-img" src={item.img} srcMobile={item.img} alt={t('sectionF_title')} />
                            <p className="product-title">{item.title}</p>
                            <p className="price">
                                {FormatMoneyLocal(item.price, 'jp')}
                                <span className="suffix">{t('price_suffix')}</span>
                            </p>
                            <p className="original-price">
                                {t('price_text')}
                                {FormatMoneyLocal(item.original_price, 'jp')}
                                {t('price_suffix')}
                            </p>
                            <EfLink
                                href={item.link}
                                className="amazon-btn"
                                dataLayer={[
                                    {
                                        event: 'uaEvent',
                                        event_name: 'buy_on_amazon',
                                        product_name: item.title,
                                        button_name: `${t('amazon_btn')}_Amazon Product Details Page`,
                                        list_name: t('sectionF_title'),
                                    },
                                ]}
                            >
                                <ICON_AMAZON />
                                {t('amazon_btn')}
                            </EfLink>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
